export default __webpack_public_path__ + "static/media/st.6fc432ad.svg";